import { KeyValue } from 'ngrx-forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { filter, map, Observable, take, withLatestFrom } from 'rxjs';

import { ActivatedRouteSnapshot } from '@angular/router';
import {
  LazyEntityFacadeInterface,
  RouterFacadeInterface,
  SharedEntityFacadeInterface,
} from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';

export abstract class BaseDetailGuard<T extends BaseDto, K extends KeyValue> {
  constructor(
    protected sharedFacade: SharedEntityFacadeInterface<T>,
    protected facade: LazyEntityFacadeInterface<T, K>,
    protected routerFacade: RouterFacadeInterface,
    protected permissionService: NgxPermissionsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const entityId = Number(route.params['entityId']);

    return this.hasEntity(entityId, route);
  }

  getOptions(route: ActivatedRouteSnapshot): any {
    return undefined;
  }

  hasEntity(id: number, route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.facade.getLoadedEntity$.pipe(
      withLatestFrom(
        this.sharedFacade.canCreate$,
        this.sharedFacade.canUpdate$,
        this.permissionService.permissions$,
        this.routerFacade.isViewOnlyMode$,
        this.facade.entityId$
      ),
      map(
        ([
          item,
          canCreate,
          canUpdate,
          permissions,
          disableForm,
          previousEntityId,
        ]) => {
          const isNew = id == 0;
          const load = !isNew && (item === undefined || item?.id !== id);
          if (load) {
            this.sharedFacade.loadSingle(id);
          } else {
            item = !isNew ? item : undefined;

            if (id !== previousEntityId) {
              this.facade.selectEntityId(id);
              this.facade.formInitialize(
                item,
                disableForm ||
                  item?.locked ||
                  (isNew ? !canCreate : !canUpdate),
                this.getOptions(route),
                permissions ? Object.keys(permissions) : []
              );
            }
          }
          return !load;
        }
      ),
      filter((res) => !!res),
      take(1)
    );
  }
}
